export enum AdminAddAdminFormItemLabel {
  Email = "Email",
  FirstName = "Ime",
  LastName = "Prezime",
}
